;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.8";import * as Sentry from '@sentry/nextjs';
import createCookieConsentGatedSentryConfig from '@framework/sentry/createCookieConsentGatedSentryConfig';

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

createCookieConsentGatedSentryConfig({ entry: 'allocate', client: true });
